<template>
	<div id="app" :class="site">
		<router-view/>
		<modal id="logout-modal" :visible="modalVisible" modalId="logout-modal" confirm="Logout" title="Confirm Logout" @confirm="confirmModal" @cancel="cancelModal">
			<p class="mt-3">Are you sure you wish to exit Password Security Portal?</p>
		</modal>
	</div>
</template>

<script>

import Modal from '@/components/Modal'
import store from '@/state'
import router from '@/router'

import tooltip from '@/directives/TooltipDirective'

export default {
	name: 'App',
	components: {Modal},
	methods:{
		cancelModal() {
			store.commit('hideModal', 'logout');
		},
		confirmModal() {
			store.commit('logout');
			store.commit('hideModal', 'logout');
			router.push('/login');
		}
	},
	computed: {
		modalVisible() {
			return store.state.modals['logout'].visible;
		},
		site() {
			return store.getters.siteName;
		}
	}
}
</script>

  



// WEBPACK FOOTER //
// src/App.vue